import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { StudentGuard } from './guards/student/student.guard';
import { TeacherGuard } from './guards/teacher/teacher.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'code',
    pathMatch: 'full',
  },
  {
    path: 'folder/:id',
    loadChildren: () =>
      import('./folder/folder.module').then((m) => m.FolderPageModule),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'login2',
    loadChildren: () =>
      import('./pages/login2/login2.module').then((m) => m.Login2PageModule),
  },
  {
    path: 'home',
    loadChildren: () =>
      import('./pages/home/home.module').then((m) => m.HomePageModule),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./pages/profile/profile.module').then((m) => m.ProfilePageModule),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'attendance',
    loadChildren: () =>
      import('./pages/attendance/attendance.module').then(
        (m) => m.AttendancePageModule
      ),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'result',
    loadChildren: () =>
      import('./pages/result/result.module').then((m) => m.ResultPageModule),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'events',
    loadChildren: () =>
      import('./pages/events/events.module').then((m) => m.EventsPageModule),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'event-details',
    loadChildren: () =>
      import('./pages/event-details/event-details.module').then(
        (m) => m.EventDetailsPageModule
      ),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'fees',
    loadChildren: () =>
      import('./pages/fees/fees.module').then((m) => m.FeesPageModule),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'parent-chat',
    loadChildren: () =>
      import('./pages/parent-chat/parent-chat.module').then((m) => m.ParentChatPageModule),
    canLoad: [AuthGuard, StudentGuard],
    canActivate: [AuthGuard, StudentGuard],
  },
  {
    path: 'pay-online',
    loadChildren: () =>
      import('./pages/pay-online/pay-online.module').then(
        (m) => m.PayOnlinePageModule
      ),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'pay-online/:id',
    loadChildren: () =>
      import('./pages/pay-online/pay-online.module').then(
        (m) => m.PayOnlinePageModule
      ),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'show-payment-history',
    loadChildren: () =>
      import('./pages/payments/payments.module').then(
        (m) => m.PaymentsPageModule
      ),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'assignment',
    loadChildren: () =>
      import('./staff-pages/assignments/assignments.module').then(
        (m) => m.AssignmentsModule
      ),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'class-work',
    loadChildren: () =>
      import('./staff-pages/class-work/class-work.module').then(
        (m) => m.ClassWorkModule
      ),
    canLoad: [AuthGuard, TeacherGuard],
    canActivate: [AuthGuard, TeacherGuard],
  },
  {
    path: 'student-class-work',
    loadChildren: () =>
      import('./student-pages/class-work/class-work.module').then(
        (m) => m.ClassWorkModule
      ),
    canLoad: [AuthGuard, StudentGuard],
    canActivate: [AuthGuard, StudentGuard],
  },
  {
    path: 'notices',
    loadChildren: () =>
      import('./staff-pages/notices/notices.module').then(
        (m) => m.NoticesModule
      ),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'timetable',
    loadChildren: () =>
      import('./pages/timetable/timetable.module').then(
        (m) => m.TimetablePageModule
      ),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'result',
    loadChildren: () =>
      import('./pages/result/result.module').then((m) => m.ResultPageModule),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'datesheet',
    loadChildren: () =>
      import('./pages/datesheet/datesheet.module').then(
        (m) => m.DatesheetPageModule
      ),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'ask-doubt',
    loadChildren: () =>
      import('./pages/ask-doubt/ask-doubt.module').then(
        (m) => m.AskDoubtPageModule
      ),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'gallery',
    loadChildren: () =>
      import('./pages/gallery/gallery.module').then((m) => m.GalleryPageModule),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'change-password',
    loadChildren: () =>
      import('./pages/change-password/change-password.module').then(
        (m) => m.ChangePasswordPageModule
      ),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'event-list',
    loadChildren: () =>
      import('./pages/event-list/event-list.module').then(
        (m) => m.EventListPageModule
      ),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'details-page',
    loadChildren: () =>
      import('./pages/details-page/details-page.module').then(
        (m) => m.DetailsPagePageModule
      ),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'support',
    loadChildren: () =>
      import('./pages/support/support.module').then((m) => m.SupportPageModule),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'notification-page',
    loadChildren: () =>
      import('./pages/notification-page/notification-page.module').then(
        (m) => m.NotificationPagePageModule
      ),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'account-setting',
    loadChildren: () =>
      import('./pages/account-setting/account-setting.module').then(
        (m) => m.AccountSettingPageModule
      ),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'student-list',
    loadChildren: () =>
      import('./pages/student-list/student-list.module').then(
        (m) => m.StudentListPageModule
      ),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'student-assignments',
    loadChildren: () =>
      import('./student-pages/assignments/assignments.module').then(
        (m) => m.AssignmentsModule
      ),
    canLoad: [AuthGuard, StudentGuard],
    canActivate: [AuthGuard, StudentGuard],
  },
  {
    path: 'code-verification',
    loadChildren: () =>
      import('./pages/code-verification/code-verification.module').then(
        (m) => m.CodeVerificationPageModule
      ),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'subject',
    loadChildren: () =>
      import('./pages/subject/subject.module').then((m) => m.SubjectPageModule),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'chapter-list',
    loadChildren: () =>
      import('./pages/chapter-list/chapter-list.module').then(
        (m) => m.ChapterListPageModule
      ),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'quiz',
    loadChildren: () =>
      import('./pages/quiz/quiz.module').then((m) => m.QuizPageModule),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'popup-component',
    loadChildren: () =>
      import('./pages/popup-component/popup-component.module').then(
        (m) => m.PopupComponentPageModule
      ),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  //Staff routs
  {
    path: 'staff-home',
    loadChildren: () =>
      import('./pages/staff-home/staff-home.module').then(
        (m) => m.StaffHomePageModule
      ),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'staff-attendance',
    loadChildren: () =>
      import('./pages/staff-attendance/staff-attendance.module').then(
        (m) => m.StaffAttendanceModule
      ),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'gradebook',
    loadChildren: () =>
      import('./staff-pages/gradebook/gradebook.module').then(
        (m) => m.GradebookPageModule
      ),
    canLoad: [AuthGuard, TeacherGuard],
    canActivate: [AuthGuard, TeacherGuard],
  },
  {
    path: 'take-attendance',
    loadChildren: () =>
      import('./staff-pages/attendance/attendance/attendance.module').then(
        (m) => m.AttendancePageModule
      ),
    canLoad: [AuthGuard, TeacherGuard],
    canActivate: [AuthGuard, TeacherGuard],
  },
  {
    path: 'staff-attendance-report',
    loadChildren: () =>
      import('./pages/staff-attendance-report/staff-attendance-report.module').then(
        (m) => m.StaffAttendanceReportModule
      ),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'code',
    loadChildren: () =>
      import('./pages/code/code.module').then((m) => m.CodePageModule),
  },
  {
    path: 'house-management',
    loadChildren: () =>
      import('./staff-pages/house-management/house-management.module').then(
        (m) => m.HouseManagementModule
      ),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'department-messages',
    loadChildren: () =>
      import('./staff-pages/department-messages/department-messages.module').then(
        (m) => m.DepartmentMessagesModule
      ),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'payroll',
    loadChildren: () =>
      import('./staff-pages/payroll/payroll.module').then(
        (m) => m.PayrollPageModule
      ),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'expenses',
    loadChildren: () =>
      import('./staff-pages/expenses/expenses.module').then(
        (m) => m.ExpensesPageModule
      ),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  },
  {
    path: 'form-teacher-students',
    loadChildren: () =>
      import('./staff-pages/form-teacher-students/form-teacher-students.module').then(
        (m) => m.FormTeacherStudentsPageModule
      ),
    canLoad: [AuthGuard, TeacherGuard],
    canActivate: [AuthGuard, TeacherGuard],
  },
  {
    path: 'admit-card',
    loadChildren: () =>
      import('./pages/admit-card/admit-card.module').then(
        (m) => m.AdmitCardPageModule
      ),
    canLoad: [AuthGuard, StudentGuard],
    canActivate: [AuthGuard, StudentGuard],
  },
  {
    path: 'report-card',
    loadChildren: () =>
      import('./pages/report-card/report-card.module').then(
        (m) => m.ReportCardPageModule
      ),
    canLoad: [AuthGuard, StudentGuard],
    canActivate: [AuthGuard, StudentGuard],
  },
  {
    path: 'learn-discover',
    loadChildren: () =>
      import('./pages/learn-discover/learn-discover.module').then(
        (m) => m.LearnDiscoverPageModule
      ),
    canLoad: [AuthGuard, StudentGuard],
    canActivate: [AuthGuard, StudentGuard],
  },
  {
    path: 'learn-discover/:id',
    loadChildren: () =>
      import('./pages/learn-discover-detail/learn-discover-detail.module').then(
        (m) => m.LearnDiscoverDetailPageModule
      ),
    canLoad: [AuthGuard, StudentGuard],
    canActivate: [AuthGuard, StudentGuard],
  },
  {
    path: 'qr-attendance',
    loadChildren: () =>
      import('./pages/qr-attendance/qr-attendance.module').then(
        (m) => m.QrAttendancePageModule
      ),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, paramsInheritanceStrategy: 'always'}),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
